import React, { useRef } from "react";
import TheMallOutletLayout from "../../../layouts/TheMallOutletLayout/TheMallOutletLayout";
import HeadPage from "../../../components/HeadPage/HeadPage";
import WrapperDetail from "../../../components/WrapperDetail/WrapperDetail";
import { fetchData } from "../../../fetcher";
import styles from "../../../styles/pages/specific-event.module.scss";
import ImageCarousel from "../../../components/ImageCarousel/ImageCarousel";
import CardCarousel from "../../../components/CardCarousel/CardCarousel";
import ScrollDown from "../../../components/ScrollDown/ScrollDown";

const NewsDetailPage = ({ menuItems, dataContent }) => {
  const scrollToRef = useRef(null)
  return (
    <TheMallOutletLayout menuItems={menuItems}>
      <div id="head" ref={scrollToRef}>
        <HeadPage {...dataContent?.head} />
      </div>
      <div className="centeredSection">
        <WrapperDetail {...dataContent?.news.card} pastEvent />
      </div>
      <div className={styles.ImageCarousel}>
        <ImageCarousel items={dataContent?.carousel?.items} bigSlides={true} />
      </div>
      <div className={styles.CardCarousel}>
        <CardCarousel
          listOfBrands={dataContent.newsCarousel.items}
          goldTitle={dataContent.newsCarousel.goldTitle}
          more={dataContent.newsCarousel.more}
          hoverText={dataContent.newsCarousel.hoverText}
          autoplay={false}
        />
      </div>
      <div className="scroll">
        <ScrollDown selector={scrollToRef} scrollTop />
      </div>
    </TheMallOutletLayout>
  );
};

NewsDetailPage.getInitialProps = async (context) => {
  let menuItems = null;
  let dataContent = null;
  const { slug } = context.query;

  const resmenu = await fetchData("/init", context.query.locale);
  const data = await fetchData(slug, context.query.locale);

  if (resmenu) {
    menuItems = resmenu.menu;
  }

  if (data) {
    dataContent = data;
  }

  return {
    menuItems: menuItems,
    dataContent: dataContent,
  };
};

export default NewsDetailPage;
